import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png"; // Background image
import pdficon from "../images/pdf-icon.jpg"; // PDF icon

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const baseURL = "https://gcbeetan.co.in/admin/downloads/"; // Backend file path


 useEffect(() => {
    fetch("https://gcbeetan.co.in/admin/api/downloads.php?category=5") // 1 = Students
      .then((res) => res.json())
      .then((data) => setNotifications(data))
      .catch((err) => console.error("Error fetching downloads:", err));
  }, []);

  return (
    <>
      <Header />
      <div className="section">
        {/* Title Section */}
        <section
          className="content-section title-top"
          style={{ backgroundImage: `url(${topback})` }}
        >
          <div className="pattern-overlay">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 title-heading">
                  <h2>Staff → Notifications</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Notifications List */}
        <div className="container mt-4">
          {notifications.length > 0 ? (
            notifications.map((notif) => {
              const link = notif.file
                ? `${baseURL}${encodeURIComponent(notif.file)}`
                : notif.externalurl;

              return (
                <div
                  className="row align-items-center mb-3 border rounded p-2"
                  key={notif.id}
                >
                  {/* File Icon */}
                  <div className="col-2 text-center">
                    <img
                      src={pdficon}
                      alt="PDF Icon"
                      className="img-fluid"
                      style={{ width: "80px" }}
                    />
                  </div>

                  {/* Title */}
                  <div className="col-6">
                    <p className="pdfpara">
                      <a href={link} target="_blank" rel="noreferrer">
                        <strong>{notif.title}</strong>
                      </a>
                    </p>
                  </div>

                  {/* Spacer */}
                  <div className="col-2"></div>

                  {/* Download Button */}
                  <div className="col-2 text-center">
                    <a
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-back"
                      style={{ width: "120px", height: "36px" }}
                    >
                      Download <i className="icon ion-ios-arrow-thin-down"></i>
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No notifications available in this category.</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Notification;
